import { InfiniteScrollComponent } from '../classes/InfiniteScrollComponent';
import { Global } from '../classes/Global';
import { PriceHelper } from '../helpers/PriceHelper';
import { GenresService } from '../genres.service';
import { StorageHelper } from '../helpers/StorageHelper';
import { Router, ActivatedRoute } from '@angular/router';
import { OnDestroy } from '@angular/core';
import { StringHelper } from '../helpers/StringHelper';
import { Cache } from './Cache';
import { LoginHelper } from '../helpers/LoginHelper';
import { AuthenticationService } from '../authentication.service';
import { InfoService } from '../info.service';
import { WishlistService } from '../wishlist.service';
import { Log } from '../helpers/Log';
import { MovieRatingsFilters } from '../movie-ratings-sliders/movie-ratings-sliders.component';
import { CustomMap } from '../multipick-dropdown/multipick-dropdown.component';
import { FilterHelper } from '../helpers/FilterHelper';
import { OwnListService } from '../own-list.service';
import { Config } from './Config';
import { SettingsService } from '../settings.service';
import { ListHelper } from '../helpers/ListHelper';
import { ThemeService } from '../theme.service';
import { SeoService } from '../seo.service';
import { takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';
import { BlocklistService } from '../blocklist.service';

export abstract class OffersParentComponent extends InfiniteScrollComponent implements OnDestroy {

  /** Emits when component is destroyed; use with takeUntil to avoid updating state after teardown (fixes "can't access dead object" in Firefox) */
  protected destroy$ = new Subject<void>();

  // Override default limit from InfiniteScrollComponent
  limit: number = 36;

  identifier: string;
  sortKey: string;
  sortPeriodKey: string;
  mediaTypes: Array<any>;
  selectedMediaType: string;
  listType: string;
  mediaTypesForDisplay: Array<any>;
  items: Array<any> = [];
  totalItemCount: number = 0;
  showSpinner = false;
  techError = false;
  genres: CustomMap[] = [];
  selectedGenres: CustomMap[] = [];
  selectedDevice;
  selectedPriceType;
  buyRentSelectedOption;
  buyRentOptions;
  selectedMusicOption;
  musicOptions;
  priceRanges: CustomMap[] = [];
  selectedPriceRanges: CustomMap[] = [];
  pricePerMovieRanges: CustomMap[] = [];
  selectedPricePerMovieRanges: CustomMap[] = [];
  selectedReleaseYear: string;
  selectedRuntime: string;
  selectedFrenchTitlesOption;
  selectedQuality;
  qualityOptions;
  sortValues = [];
  sortPeriodValues = [];
  selectedAdvisoryRatings: CustomMap[] = [];
  advisoryRatings: CustomMap[] = [];
  moviesAnywhereOptions = [];
  itunesExtrasOptions = [];
  offersFilterOptions = [];
  selectedOffersFilterOption;
  soundOptions = [];
  selectedMAOption;
  selectedItunesExtrasOption;
  selectedSoundOption;
  hdrFormatOptions: CustomMap[] = [];
  selectedHdrFormatOptions: CustomMap[] = [];
  movieRatingsFilters: MovieRatingsFilters = new MovieRatingsFilters();
  isFiltersPanelOpen = false;
  cacheResults = true;
  cacheGenres = true;
  studioOptions = [];
  selectedStudioOptions;
  movieRatingsSelection: string;
  audiotrackOptions = [];
  selectedAudiotrackOption;
  currentYear: number = this.getCurrentYear();
  bundleFilterOptions = [];
  selectedBundleFilterOption;

  constructor(
    protected genresService: GenresService,
    protected router: Router,
    protected route: ActivatedRoute,
    protected authenticationService: AuthenticationService,
    protected infoService: InfoService,
    protected wishlistService: WishlistService,
    protected blocklistService: BlocklistService,
    protected ownlistService: OwnListService,
    protected settingsService: SettingsService,
    protected themeService: ThemeService,
    protected seoService: SeoService) {
    super();

    this.buyRentOptions = this.getBuyRentOptions();
  }

  abstract reload(newUrl: boolean, replaceUrl?: boolean);
  abstract initSorting();
  abstract getOffers();

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }

  onInit() {

    window.scrollTo(0, 0);

    if (this.authenticationService.isLoggedIn()) {

      if(this.identifier != Global.MY_PURCHASES) {
        this.getShortOwnList();
      }
      if(this.identifier != Global.BLOCKLIST) {
        this.getShortBlocklist();
      }

      this.getShortWishlist();
    }

    this.initGenre();
    this.initMediaTypes();
    this.initSorting();
    this.initDevices();
    this.initPriceTypes();
    this.initBuyRentOptions();
    this.initMusicOptions();
    this.initPriceRange();
    this.initPricePerMovieRange();
    this.initYears();
    this.initRuntime();
    this.initFrenchTitles();
    this.initQuality();
    this.initAdvisoryRating();
    this.initSound();
    this.initMoviesAnywhere();
    this.initItunesExtras();
    this.initOffersFilter();
    this.initHdrFormat();
    this.initStudio();
    this.initMovieRatingsFilters();
    this.initAudiotrackOptions();
    this.initBundleFilter();

    this.isFiltersPanelOpen = FilterHelper.getFilterOpen();
  }

  getCurrentYear(): number {
    return new Date().getFullYear();
  }

  showBuyRentOption(): boolean {
    return this.listType !== Global.BUNDLES && this.listType !== Global.PREORDER &&
      this.listType !== Global.JUST_RELEASED && this.listType !== Global.NEW_ON_PRIME_VIDEO;
  }

  getDateSeparatorMode(): string {
    if (this.listType == "preorder" && this.sortKey == Global.RELEASE_DATE) {
      return "month";
    }
    return "day";
  }

  getMediaTypeForGetOffers(): string {
    let mediaType = Global.getMediaType();
    if(mediaType == Global.MOVIES || mediaType == Global.BUYMOVIES || mediaType == Global.RENTALMOVIES) {
      if(this.identifier == Global.MY_PURCHASES || this.identifier == Global.BLOCKLIST) {
        return Global.MOVIES;
      }
      if(this.showBuyRentOption() && this.buyRentSelectedOption && this.buyRentSelectedOption.type == "rent") {
        mediaType = Global.RENTALMOVIES;
      }
      else {
        mediaType = Global.BUYMOVIES;
      }
    }
    else if(mediaType == Global.SEASONS && (this.identifier == Global.MY_PURCHASES || this.identifier == Global.BLOCKLIST)) {
      return Global.TV;
    }
    else if((mediaType == Global.ALBUMS || mediaType == Global.SINGLES) && (this.identifier == Global.MY_PURCHASES || this.identifier == Global.BLOCKLIST)) {
      return Global.MUSIC;
    }
    return mediaType;
  }

  getSavedGenres() {
    return StorageHelper.getInstance().get(this.getGenreStorageKey());
  }

  getReleaseYear(): string {
    return StorageHelper.getInstance().getFilter(Global.getStore(), Global.getMediaType(), Global.getListType(), StorageHelper.keys.releaseYear);
  }

  getRuntime(): string {
    return StorageHelper.getInstance().getFilter(Global.getStore(), Global.getMediaType(), Global.getListType(), StorageHelper.keys.runtime);
  }

  getFrenchTitles() {
    return StorageHelper.getInstance().getFilter(Global.getStore(), Global.getMediaType(), Global.getListType(), StorageHelper.keys.hideFrenchTitles);
  }

  getPriceRange() {
    return StorageHelper.getInstance().getFilter(Global.getStore(), Global.getMediaType(), Global.getListType(), StorageHelper.keys.priceRange);
  }

  getPricePerMovieRange() {
    return StorageHelper.getInstance().getFilter(Global.getStore(), Global.getMediaType(), Global.getListType(),
      StorageHelper.keys.pricePerMovieRange);
  }

  getPriceType() {
    return StorageHelper.getInstance().getFilter(Global.getStore(), Global.getMediaType(), Global.getListType(), StorageHelper.keys.priceType);
  }

  getSort(list: string) {
    return StorageHelper.getInstance().getFilter(Global.getStore(), Global.getMediaType(), list, StorageHelper.keys.sort);
  }

  getSortPeriod() {
    return StorageHelper.getInstance().getFilter(Global.getStore(), Global.getMediaType(), Global.getListType(), StorageHelper.keys.sortPeriod);
  }

  getDeviceType() {
    return StorageHelper.getInstance().getFilter(Global.getStore(), Global.getMediaType(), Global.getListType(), StorageHelper.keys.device);
  }

  getAdvisoryRating() {
    return StorageHelper.getInstance().getFilter(Global.getStore(), Global.getMediaType(), Global.getListType(), StorageHelper.keys.advisoryRating);
  }

  getMoviesAnyhere() {
    return StorageHelper.getInstance().getFilter(Global.getStore(), Global.getMediaType(), Global.getListType(), StorageHelper.keys.moviesAnywhere);
  }

  getItunesExtras() {
    return StorageHelper.getInstance().getFilter(Global.getStore(), Global.getMediaType(), Global.getListType(), StorageHelper.keys.itunesExtras);
  }

  getOffersFilter() {
    return StorageHelper.getInstance().getFilter(Global.getStore(), Global.getMediaType(), Global.getListType(), StorageHelper.keys.offersFilter);
  }

  getSound() {
    return StorageHelper.getInstance().getFilter(Global.getStore(), Global.getMediaType(), Global.getListType(), StorageHelper.keys.sound);
  }

  getHdrFormat() {
    return StorageHelper.getInstance().getFilter(Global.getStore(), Global.getMediaType(), Global.getListType(), StorageHelper.keys.hdrFormat);
  }

  getStudio() {
    return StorageHelper.getInstance().getFilter(Global.getStore(), Global.getMediaType(), Global.getListType(), StorageHelper.keys.studio);
  }

  getMovieRatingsFilters() {
    return StorageHelper.getInstance().getFilter(Global.getStore(), Global.getMediaType(), Global.getListType(), StorageHelper.keys.movieRatingsFilters);
  }

  getAudiotrack() {
    return StorageHelper.getInstance().getFilter(Global.getStore(), Global.getMediaType(), Global.getListType(), StorageHelper.keys.audiotrack);
  }

  getBundleFilter() {
    return StorageHelper.getInstance().getFilter(Global.getStore(), Global.getMediaType(), Global.getListType(), StorageHelper.keys.showBundles);
  }

  protected saveFilterDefault(filterKey: string, value: any) {
    StorageHelper.getInstance().saveFilter(Global.getStore(), Global.getMediaType(), this.listType, filterKey, value);
  }

  protected getValidOptionOrDefault(savedOption: any, options: Array<any>, property: string, filterKey: string, defaultIndex?: number) {
    const index = defaultIndex != null ? defaultIndex : 0;
    if (!options || !Array.isArray(options) || options.length === 0) {
      return null;
    }

    const fallback = options[index] ? options[index] : options[0];
    if (savedOption && typeof savedOption === 'object' && savedOption[property] != null) {
      const savedValue = savedOption[property].toString();
      for (let i = 0; i < options.length; i++) {
        if (options[i] && options[i][property] != null && options[i][property].toString() === savedValue) {
          if (JSON.stringify(savedOption) !== JSON.stringify(options[i])) {
            this.saveFilterDefault(filterKey, options[i]);
          }
          return options[i];
        }
      }
    }

    this.saveFilterDefault(filterKey, fallback);
    return fallback;
  }

  protected getValidMultiOptionsOrDefault(savedOptions: any, options: CustomMap[], filterKey: string): CustomMap[] {
    if (!options || !Array.isArray(options) || options.length === 0) {
      return [];
    }

    const fallback = [options[0]];
    if (savedOptions && typeof savedOptions === 'object' && !Array.isArray(savedOptions) && savedOptions.key != null) {
      savedOptions = [savedOptions];
    }

    if (!savedOptions || !Array.isArray(savedOptions) || savedOptions.length === 0) {
      this.saveFilterDefault(filterKey, fallback);
      return fallback;
    }

    const selectedOptions: CustomMap[] = [];
    for (const savedOption of savedOptions) {
      if (!savedOption || typeof savedOption !== 'object' || savedOption.key == null) {
        continue;
      }

      let matchedOption: CustomMap = null;
      const savedKey = savedOption.key.toString();
      for (const option of options) {
        if (option && option.key != null && option.key.toString() === savedKey) {
          matchedOption = option;
          break;
        }
      }

      if (matchedOption) {
        selectedOptions.push(matchedOption);
      }
    }

    if (selectedOptions.length > 0) {
      this.saveFilterDefault(filterKey, selectedOptions);
      return selectedOptions;
    }

    this.saveFilterDefault(filterKey, fallback);
    return fallback;
  }

  protected getValidRangeOrDefault(savedRange: any, defaultRange: string, filterKey: string): string {
    if (typeof savedRange === 'string' && /^[0-9]+-[0-9]+$/.test(savedRange)) {
      return savedRange;
    }

    this.saveFilterDefault(filterKey, defaultRange);
    return defaultRange;
  }

  shouldShowBundleFilter(): boolean {
    const store = Global.getStore();
    const isMoviesOrSeasons = this.selectedMediaType === 'movies' || this.selectedMediaType === 'seasons';
    const isItunesOrVudu = store === Global.ITUNES || store === Global.VUDU;
    const excludedListTypes = [
      Global.BUNDLES,
      Global.MOVIES_4K,
      Global.UPGRADED_4K,
      Global.MOVIES_3D,
      Global.PREORDER
    ];
    const isExcludedListType = excludedListTypes.indexOf(this.listType) !== -1;

    return isMoviesOrSeasons && isItunesOrVudu && !isExcludedListType;
  }

  shouldShowRuntimeFilter(): boolean {
    return this.selectedMediaType === 'movies';
  }

  shouldShowFrenchTitlesFilter(): boolean {
    return this.shouldShowRuntimeFilter() && Global.getStore() === Global.ITUNES && Global.getCountry() === Global.countries.ca.key;
  }

  shouldShowPricePerMovieFilter(): boolean {
    const mediaType = Global.getMediaType();
    const isMovieMediaType = mediaType === Global.BUYMOVIES || mediaType === Global.RENTALMOVIES ||
      mediaType === Global.MOVIES || this.selectedMediaType === 'movies';

    return Global.getStore() === Global.ITUNES && this.listType === Global.BUNDLES && isMovieMediaType;
  }

  initMediaTypes(){

    this.mediaTypesForDisplay = Global.mediaTypesForSelector[Global.getStore()];
    this.mediaTypes = Global.supportedMediaTypes[Global.getStore()];
    //If we had a mediaType that doesn't exist in this new selected store,
    //choose the first one of the store
    if (this.mediaTypes && this.mediaTypes instanceof Array && this.mediaTypes.length > 0) {
      if (this.mediaTypes.indexOf(Global.getMediaType()) === -1) {
        this.mediaChanged(this.mediaTypes[0]);
      }
    }

    if (this.selectedMediaType == null) {
      this.selectedMediaType = Global.getMediaTypeForSelector();
    }
  }

  initGenre() {

    //For new genre menu
    //if it's the first time we have the new menu, delete all saved genres
    if(!StorageHelper.getInstance().get("new_genre_menu")) {
      StorageHelper.getInstance().removeAllWithPrefix("genre_");
      StorageHelper.getInstance().save("new_genre_menu", 1);
    }

    const savedGenres = this.getSavedGenres();
    if (savedGenres && savedGenres instanceof Array) {
      this.selectedGenres = savedGenres;
    }
  }

  initQuality() {
    this.qualityOptions = this.getQualityOptions();
    this.selectedQuality = this.getValidOptionOrDefault(this.getSavedQuality(), this.qualityOptions, 'type', StorageHelper.keys.quality);
  }

  initDevices() {
    this.selectedDevice = this.getValidOptionOrDefault(this.getDeviceType(), this.getDevices(), 'type', StorageHelper.keys.device);
  }

  initPriceTypes() {
    this.selectedPriceType = this.getValidOptionOrDefault(this.getPriceType(), this.getPriceTypes(), 'type', StorageHelper.keys.priceType);
  }

  initBuyRentOptions() {
    this.buyRentOptions = this.getBuyRentOptions();
    const savedOption = Global.getBuyRent();
    if (savedOption && typeof savedOption === 'object' && savedOption.type != null) {
      const matchingOption = this.buyRentOptions.filter(option => option && option.type === savedOption.type)[0];
      this.buyRentSelectedOption = matchingOption ? matchingOption : this.buyRentOptions[0];
    }
    else {
      this.buyRentSelectedOption = this.buyRentOptions[0];
    }
    if (!savedOption || this.buyRentSelectedOption.type !== savedOption.type) {
      StorageHelper.getInstance().save(StorageHelper.keys.buyRent, this.buyRentSelectedOption);
    }
  }

  initMusicOptions() {
    this.musicOptions = this.getMusicOptions();
    const mediaType = Global.getMediaType();
    const index = this.musicOptions.map(m => m.type).indexOf(mediaType);
    if(index >= 0) {
      this.selectedMusicOption = this.musicOptions[index];
    }
    else {
      this.selectedMusicOption = this.musicOptions[0];
    }
  }

  initYears() {
    const releaseYear = this.getReleaseYear();
    if(!releaseYear) {
      this.selectedReleaseYear = "1900-" + this.currentYear;
    }
    else if(releaseYear == "1900-" + (this.currentYear - 1)) {
      this.selectedReleaseYear = "1900-" + this.currentYear;
    }
    else {
      this.selectedReleaseYear = this.getValidRangeOrDefault(releaseYear, "1900-" + this.currentYear, StorageHelper.keys.releaseYear);
    }
  }

  initRuntime() {
    this.selectedRuntime = this.getValidRangeOrDefault(this.getRuntime(), "1-350", StorageHelper.keys.runtime);
  }

  initFrenchTitles() {
    this.selectedFrenchTitlesOption = this.getValidOptionOrDefault(this.getFrenchTitles(), this.getFrenchTitlesOptions(), 'type', StorageHelper.keys.hideFrenchTitles);
  }

  initPriceRange() {
    const allItem: CustomMap = {key: "all", value: this.getString('all')};
    this.priceRanges = this.getPriceRangeOptions();
    const priceRange = this.getPriceRange();
    const priceRangeOptions = [allItem].concat(this.priceRanges);
    this.selectedPriceRanges = this.getValidMultiOptionsOrDefault(priceRange, priceRangeOptions, StorageHelper.keys.priceRange);

  }

  initPricePerMovieRange() {
    const allItem: CustomMap = {key: "all", value: this.getString('all')};
    this.pricePerMovieRanges = this.getPricePerMovieRangeOptions();
    const pricePerMovieRange = this.getPricePerMovieRange();
    const pricePerMovieRangeOptions = [allItem].concat(this.pricePerMovieRanges);
    this.selectedPricePerMovieRanges = this.getValidPricePerMovieOptionsOrDefault(pricePerMovieRange,
      pricePerMovieRangeOptions, StorageHelper.keys.pricePerMovieRange);
  }

  initAdvisoryRating() {

    //For new studio menu
    //if it's the first time we have the new menu, delete all saved studios
    if(!StorageHelper.getInstance().get("new_ar_menu")) {
      StorageHelper.getInstance().clear(StorageHelper.keys.advisoryRating);
      StorageHelper.getInstance().save("new_ar_menu", 1);
    }

    this.advisoryRatings = this.getAdvisoryRatings();
    this.selectedAdvisoryRatings = this.getValidMultiOptionsOrDefault(this.getAdvisoryRating(), this.advisoryRatings, StorageHelper.keys.advisoryRating);
  }

  initMoviesAnywhere() {
    this.moviesAnywhereOptions = this.getMoviesAnywhereOptions();
    this.selectedMAOption = this.getValidOptionOrDefault(this.getMoviesAnyhere(), this.moviesAnywhereOptions, 'type', StorageHelper.keys.moviesAnywhere);
  }

  initItunesExtras() {
    this.itunesExtrasOptions = this.getItunesExtrasOptions();
    this.selectedItunesExtrasOption = this.getValidOptionOrDefault(this.getItunesExtras(), this.itunesExtrasOptions, 'type', StorageHelper.keys.itunesExtras);
  }

  initOffersFilter() {
    this.offersFilterOptions = this.getOfferFilterOptions();

    if (this.listType == "onsale") {
      this.selectedOffersFilterOption = this.getValidOptionOrDefault(this.getOffersFilter(), this.offersFilterOptions, 'type', StorageHelper.keys.offersFilter, 1);
    }
    else {
      this.selectedOffersFilterOption = this.getValidOptionOrDefault(this.getOffersFilter(), this.offersFilterOptions, 'type', StorageHelper.keys.offersFilter);
    }
  }

  initSound() {
    this.soundOptions = this.getSoundOptions();
    this.selectedSoundOption = this.getValidOptionOrDefault(this.getSound(), this.soundOptions, 'type', StorageHelper.keys.sound);
  }

  initHdrFormat() {

    //For new hdr menu
    //if it's the first time we have the new menu, delete all saved hdrFormats
    if(!StorageHelper.getInstance().get("new_hdr_menu")) {
      StorageHelper.getInstance().clear(StorageHelper.keys.hdrFormat);
      StorageHelper.getInstance().save("new_hdr_menu", 1);
    }

    this.hdrFormatOptions = this.getHdrFormatOptions();
    this.selectedHdrFormatOptions = this.getValidMultiOptionsOrDefault(this.getHdrFormat(), this.hdrFormatOptions, StorageHelper.keys.hdrFormat);

  }

  initStudio() {

    //For new studio menu
    //if it's the first time we have the new menu, delete all saved studios
    if(!StorageHelper.getInstance().get("new_studio_menu")) {
      StorageHelper.getInstance().clear(StorageHelper.keys.studio);
      StorageHelper.getInstance().save("new_studio_menu", 1);
    }

    this.studioOptions = this.getStudioOptions();
    this.selectedStudioOptions = this.getValidMultiOptionsOrDefault(this.getStudio(), this.studioOptions, StorageHelper.keys.studio);
  }

  initMovieRatingsFilters() {
    const savedValues: MovieRatingsFilters = this.getMovieRatingsFilters();
    if (savedValues && savedValues.imdb != null &&
      savedValues.rotten != null &&
      savedValues.letterboxd != null &&
      savedValues.metacritic != null)
    {
      this.movieRatingsFilters.setImdb(savedValues.imdb);
      this.movieRatingsFilters.setRotten(savedValues.rotten);
      this.movieRatingsFilters.setLetterboxd(savedValues.letterboxd);
      this.movieRatingsFilters.setMeta(savedValues.metacritic);
    }
    else if (savedValues) {
      this.saveFilterDefault(StorageHelper.keys.movieRatingsFilters, this.movieRatingsFilters);
    }
    this.updateMovieRatingsSelection();
  }

  initAudiotrackOptions() {
    this.audiotrackOptions = this.getAudiotrackOptions();
    this.selectedAudiotrackOption = this.getValidOptionOrDefault(this.getAudiotrack(), this.audiotrackOptions, 'type', StorageHelper.keys.audiotrack);
  }

  initBundleFilter() {
    this.bundleFilterOptions = this.getBundleFilterOptions();
    this.selectedBundleFilterOption = this.getValidOptionOrDefault(this.getBundleFilter(), this.bundleFilterOptions, 'type', StorageHelper.keys.showBundles);
  }

  resetMovieRatingsFilters() {
    this.applyMovieRatingsFilter(new MovieRatingsFilters(0, 0, 0));
  }

  loadGenreAndItems(url?: string) {

    this.setSpecialSEO();

    // The url can be passed. It is necessary for the reload() function
    // because the router event is not called yet so the url in cache is wrong
    this.resultsEndReached = false;

    //First get data from cache, if it's missing, value = false
    const genresPresentInCache = this.loadGenresFromCache(url);
    let itemsPresentInCache = false;
    if (genresPresentInCache == true) {
      itemsPresentInCache = this.loadItemsFromCache(url);
    }

    if (!genresPresentInCache) {
      //Gets the genres and load the offers when the genres return
      this.getGenres(this.loadOffers.bind(this));
    }
    else if (!itemsPresentInCache) {
      //Genres already loaded, load items only
      this.loadOffers();
    }
  }

  getMediaType() {
    return Global.getMediaType();
  }

  hideBecausePurchased(item): boolean {
    if (this.identifier !== "my-purchases" && this.settingsService.hidePurchasedItems === true) {
      return ListHelper.isItemInOwnlist(item);
    }
    return false;
  }

  /**
   * Counts the number of items that are visible (not hidden by "Hide purchased items" filter).
   * This is needed because the ownlist filter is applied in the template with *ngIf,
   * so we need to know how many items are actually visible to determine if we need to load more.
   */
  countVisibleItems(): number {
    if (!this.items || this.items.length === 0) {
      return 0;
    }
    // If hide purchased is not active, all items are visible
    if (this.identifier === "my-purchases" || this.settingsService.hidePurchasedItems !== true) {
      return this.items.length;
    }
    // Count items that are not in the ownlist
    let visibleCount = 0;
    for (let i = 0; i < this.items.length; i++) {
      if (!ListHelper.isItemInOwnlist(this.items[i])) {
        visibleCount++;
      }
    }
    return visibleCount;
  }

  /**
   * Checks if we need to load more items because too few are visible due to "Hide purchased items" filter.
   * We need enough items to fill the viewport and enable scrolling, otherwise infinite scroll won't trigger.
   */
  shouldLoadMoreDueToOwnlistFilter(): boolean {
    // Only relevant if hide purchased items is enabled
    if (this.identifier === "my-purchases" || this.settingsService.hidePurchasedItems !== true) {
      return false;
    }
    // Don't load more if we've already reached the end
    if (this.resultsEndReached) {
      return false;
    }
    // Check if we have fewer visible items than our limit (meaning not enough to enable scrolling)
    const visibleCount = this.countVisibleItems();
    // Use limit as the threshold - if fewer visible items than one page, load more
    return visibleCount < this.limit;
  }

  setSpecialSEO() {
    /*if(this.listType == Global.BLACK_FRIDAY) {
      if(Global.getStore() == Global.ITUNES) {
        this.seoService.setTitle(this.getString('itunesBlackFridayTitle'));
        this.seoService.setMetaDescription(this.getString('itunesBlackFridayDesc'));
      }
      else if(Global.getStore() == Global.AMAZON) {
        this.seoService.setTitle(this.getString('amazonBlackFridayTitle'));
        this.seoService.setMetaDescription(this.getString('amazonBlackFridayDesc'));
      }
      else if(Global.getStore() == Global.VUDU) {
        this.seoService.setTitle(this.getString('vuduBlackFridayTitle'));
        this.seoService.setMetaDescription(this.getString('vuduBlackFridayDesc'));
      }
      else if(Global.getStore() == Global.GOOGLEPLAY) {
        this.seoService.setTitle(this.getString('googlePlayBlackFridayTitle'));
        this.seoService.setMetaDescription(this.getString('googlePlayBlackFridayDesc'));
      }
    }*/
    //Wird direkt im onSale Component erledigt
  }

  loadOffers() {

    this.showSpinner = true;
    this.isLoading = true;
    this.offset = 0;
    this.techError = false;
    this.previousScrollY = -1;
    //this.items = [];
    this.getOffers().pipe(takeUntil(this.destroy$)).subscribe(res => {

      if (res && res.results){

        const mediaType = this.getMediaTypeForGetOffers();

        //Ensure there are not null items
        let tmpArray2 = [];
        const tmpArray = res.results[mediaType];
        if (tmpArray && tmpArray.length > 0) {
          for (let i = 0; i < tmpArray.length; i++) {
            if (tmpArray[i] != null) {
              tmpArray2.push(tmpArray[i]);
            }
          }
        }

        const lengthBeforeLocalFilters = tmpArray2.length;
        tmpArray2 = this.filterItemsBySelectedPricePerMovie(tmpArray2, mediaType);

        // filter out items that appear in the blocklist (except for Blocklist and My Purchases pages)
        const lengthBeforeBlocklist = tmpArray2.length;
        if (this.identifier != Global.BLOCKLIST && this.identifier != Global.MY_PURCHASES) {
          // Use optimized Set-based filtering
          tmpArray2 = ListHelper.filterItemsByBlocklist(tmpArray2, Global.getStore(), Global.getMediaTypeForWishlistRequest());
        }
        const lengthAfterBlocklist = tmpArray2.length;
        // Mark as end reached if no items returned or fewer items than requested limit
        if (tmpArray2 == null || lengthBeforeLocalFilters === 0 || lengthBeforeLocalFilters < this.limit) {
          this.resultsEndReached = true;
        }
        if (this.cacheResults) {
          this.addToCache({ items: tmpArray2, offset: this.offset });
        }
        this.items = tmpArray2;

        if (res.totalItemCount && res.totalItemCount[mediaType] != null) {
          this.totalItemCount = res.totalItemCount[mediaType];
        } else {
          this.totalItemCount = this.items ? this.items.length : 0;
        }
        // if all items were in the blocklist, load some more directly
        if(lengthBeforeLocalFilters > 0 && lengthAfterBlocklist == 0) {
          this.loadMoreItems();
          return; // Early return, loadMoreItems will handle the rest
        }
      }
      this.showSpinner = false;
      this.isLoading = false;

      // Load more items if viewport is large or if too few visible items due to "Hide purchased items" filter
      if (window.innerHeight > 1100 || this.shouldLoadMoreDueToOwnlistFilter()) {
        this.loadMoreItems();
      }

      }, err => {

        this.techError = true;
        this.showSpinner = false;
        this.isLoading = false;

        Log.getInstance().d(err);
      });
  }

  getFiltersString(): string {

    if(!this.selectedDevice) { this.selectedDevice = this.getDevices()[0]; }
    if(!this.buyRentSelectedOption) { this.buyRentSelectedOption = this.getBuyRentOptions()[0]; }
    if(!this.selectedPriceType) { this.selectedPriceType = this.getPriceTypes()[0]; }
    if(!this.selectedMusicOption) { this.selectedMusicOption = this.getMusicOptions()[0]; }
    if(!this.selectedQuality) { this.selectedQuality = this.getQualityOptions()[0]; }
    if(!this.selectedSoundOption) { this.selectedSoundOption = this.getSoundOptions()[0]; }
    if(!this.selectedMAOption) { this.selectedMAOption = this.getMoviesAnywhereOptions()[0]; }
    if(!this.selectedItunesExtrasOption) { this.selectedItunesExtrasOption = this.getItunesExtrasOptions()[0]; }
    if (!this.selectedOffersFilterOption) { this.selectedOffersFilterOption = this.getOfferFilterOptions()[0]; }
    if(!this.selectedStudioOptions) { this.selectedStudioOptions = [this.getStudioOptions()[0]]; }
    if(!this.selectedAudiotrackOption) { this.selectedAudiotrackOption = this.getAudiotrackOptions()[0]; }
    if (!this.selectedBundleFilterOption) { this.selectedBundleFilterOption = this.getBundleFilterOptions()[0]; }
    if (!this.selectedFrenchTitlesOption) { this.selectedFrenchTitlesOption = this.getFrenchTitlesOptions()[0]; }

    //This string combines all the filters to use in the cache key
    let filtersString = this.sortKey + JSON.stringify(this.selectedGenres) + this.selectedDevice["type"] +
    this.selectedPriceType["type"] + this.buyRentSelectedOption["type"] +
    this.selectedMusicOption["type"] + JSON.stringify(this.selectedPriceRanges) +
    this.selectedQuality["type"] + JSON.stringify(this.selectedAdvisoryRatings) +
    this.selectedSoundOption["type"] +
    this.selectedMAOption["type"] + JSON.stringify(this.selectedHdrFormatOptions) +
    this.selectedItunesExtrasOption["type"] +
      this.selectedOffersFilterOption["type"] +
    JSON.stringify(this.selectedStudioOptions) + this.movieRatingsFilters.toString() +
    this.selectedAudiotrackOption["type"] + this.selectedReleaseYear + this.selectedRuntime + this.sortPeriodKey +
    this.selectedFrenchTitlesOption["type"];
    if (this.selectedBundleFilterOption) {
      filtersString += this.selectedBundleFilterOption["type"];
    }
    if (this.selectedPricePerMovieRanges) {
      filtersString += JSON.stringify(this.selectedPricePerMovieRanges);
    }

    return filtersString;
  }

  addToCache(data: any, urlSpecification?: string){
    const cache = Cache.getInstance();
    let url = cache.getCurrentUrl(this);
    if (urlSpecification) { url = urlSpecification + '_' + url; }
    else { url = url + this.getFiltersString(); }
    cache.addData(url, data);
  }

  loadItemsFromCache(url?: string): boolean {
    const cache = Cache.getInstance();
    if (!url) { url = cache.getCurrentUrl(this); }
    const data =  cache.getData(url + this.getFiltersString());
    if (data){

      let items = data["items"];
      // filter out items that appear in the blocklist (except for Blocklist and My Purchases pages)
      if (this.identifier != Global.BLOCKLIST && this.identifier != Global.MY_PURCHASES) {
        // Use optimized Set-based filtering
        items = ListHelper.filterItemsByBlocklist(items, Global.getStore(), Global.getMediaTypeForWishlistRequest());
      }
      this.items = items;

      this.offset = data['offset'];
      return (this.items && this.items.length > 0);
    }
    return false;
  }

  loadGenresFromCache(url?: string): boolean {
    const cache = Cache.getInstance();
    if (!url) { url = cache.getCurrentUrl(this); }
    this.genres = cache.getData('genres_' + url);

    if (this.genres && this.genres.length > 0) {
      this.updateGenreSelection();
      return true;
    }
    return false;

  }

  updateGenreSelection() {

    const savedGenres: CustomMap[] = this.getSavedGenres();
    if (savedGenres && savedGenres instanceof Array && savedGenres.length > 0) {
      const validSavedGenres: CustomMap[] = [];
      for (let savedGenre of savedGenres) {
        const matchingGenre = this.getMatchingGenre(savedGenre);
        if (matchingGenre) {
          validSavedGenres.push(matchingGenre);
        }
      }

      if (validSavedGenres.length > 0) {
        this.selectedGenres = validSavedGenres;
        StorageHelper.getInstance().save(this.getGenreStorageKey(), this.selectedGenres);
      }
      else {
        this.selectedGenres = [this.genres[0]];
        StorageHelper.getInstance().save(this.getGenreStorageKey(), this.selectedGenres);
      }
    }
    else {
      this.selectedGenres = [this.genres[0]];
      StorageHelper.getInstance().save(this.getGenreStorageKey(), this.selectedGenres);
    }

  }

  getMatchingGenre(savedGenre: CustomMap): CustomMap {
    if (!savedGenre || savedGenre.key == null || !this.genres) {
      return null;
    }

    const savedGenreKey = savedGenre.key.toString();
    for (let genre of this.genres) {
      if (genre && genre.key != null && genre.key.toString() === savedGenreKey) {
        return genre;
      }
    }
    return null;
  }

  loadMoreItems() {

    if(this.techError) {
      return;
    }

    this.showSpinner = true;
    this.isLoading = true;
    this.offset += this.limit;
    this.getOffers().pipe(takeUntil(this.destroy$)).subscribe(res => {

      if (this.items && res && res.results){

        const mediaType = this.getMediaTypeForGetOffers();

        //This was the line before
        //let newItems = res.results[Global.getMediaType()];
        //the following is to prevent the crash on 23.02.2018
        //where an item is null
        let tmpArray2 = [];
        const tmpArray = res.results[mediaType];
        if (tmpArray && tmpArray.length > 0) {
          for (let i = 0; i < tmpArray.length; i++) {
            if (tmpArray[i] != null) {
              tmpArray2.push(tmpArray[i]);
            }
          }
        }

        const lengthBeforeLocalFilters = tmpArray2.length;
        const newItems = this.filterItemsBySelectedPricePerMovie(tmpArray2, mediaType);

        // filter out items that appear in the blocklist (except for Blocklist and My Purchases pages)
        if (this.identifier != Global.BLOCKLIST && this.identifier != Global.MY_PURCHASES) {
          // Use optimized Set-based filtering
          const filteredNewItems = ListHelper.filterItemsByBlocklist(newItems, Global.getStore(), Global.getMediaTypeForWishlistRequest());
          if (filteredNewItems && filteredNewItems.length > 0) {
            this.items = this.items.concat(filteredNewItems);
            if (this.cacheResults) {
              this.addToCache({ items: this.items, offset: this.offset });
            }
            // Check if we still need more visible items due to "Hide purchased items" filter
            if (this.shouldLoadMoreDueToOwnlistFilter()) {
              this.loadMoreItems();
              return; // Early return, recursive call will handle the rest
            }
          }
          else if (!filteredNewItems || filteredNewItems.length === 0) {
            // If all new items were filtered, try loading more
            if (lengthBeforeLocalFilters > 0) {
              this.loadMoreItems();
              return; // Early return, recursive call will handle the rest
            } else {
              this.resultsEndReached = true;
            }
          }
        } else {
          if (newItems && newItems.length > 0) {
            this.items = this.items.concat(newItems);
            if (this.cacheResults) {
              this.addToCache({ items: this.items, offset: this.offset });
            }
          }
          else if (!newItems || newItems.length === 0) {
            this.resultsEndReached = true;
          }
        }

      }
      this.isLoading = false;
      this.showSpinner = false;

    }, err => {
      this.isLoading = false;
      this.showSpinner = false;
      Log.getInstance().d(err);
    });
  }

  formatMultiSelectionForServer(selectedItems: CustomMap[], allItems: CustomMap[]): string {
    if (!selectedItems || !allItems || !Array.isArray(selectedItems) || !Array.isArray(allItems)) {
      return '';
    }
    if (selectedItems.length === allItems.length && allItems.length > 0 && allItems[0]) {
      return allItems[0].key.toString(); //the genre "all" is always the first
    }
    else if (selectedItems.length > 0){
      return selectedItems.map(x => x.key).sort().join();
    }
    return '';
  }

  protected getValidPricePerMovieOptionsOrDefault(savedOptions: any, options: CustomMap[], filterKey: string): CustomMap[] {
    if (!options || !Array.isArray(options) || options.length === 0) {
      return [];
    }

    const fallback = [options[0]];
    if (savedOptions && typeof savedOptions === 'object' && !Array.isArray(savedOptions) && savedOptions.key != null) {
      savedOptions = [savedOptions];
    }

    if (!savedOptions || !Array.isArray(savedOptions) || savedOptions.length === 0) {
      this.saveFilterDefault(filterKey, fallback);
      return fallback;
    }

    const selectedOptions: CustomMap[] = [];
    for (const savedOption of savedOptions) {
      if (!savedOption || typeof savedOption !== 'object' || savedOption.key == null) {
        continue;
      }

      let matchedOption: CustomMap = null;
      const savedKey = savedOption.key.toString();
      for (const option of options) {
        if (option && option.key != null && option.key.toString() === savedKey) {
          matchedOption = option;
          break;
        }
      }

      if (matchedOption) {
        selectedOptions.push(matchedOption);
      }
      else if (this.isValidPriceRangeKey(savedKey)) {
        selectedOptions.push({
          key: savedKey,
          value: savedOption.value != null ? savedOption.value.toString() : savedKey
        });
      }
    }

    if (selectedOptions.length > 0) {
      this.saveFilterDefault(filterKey, selectedOptions);
      return selectedOptions;
    }

    this.saveFilterDefault(filterKey, fallback);
    return fallback;
  }

  protected filterItemsBySelectedPricePerMovie(items: any[], mediaType: string): any[] {
    const rangeKey = this.getSelectedPricePerMovieRangeKey();
    if (!items || !rangeKey || rangeKey === 'all' || Global.getStore() !== Global.ITUNES ||
      this.listType !== Global.BUNDLES || mediaType !== Global.BUYMOVIES) {
      return items;
    }

    const filteredItems = [];
    for (const item of items) {
      const pricePerMovie = this.getPricePerMovieValueForItem(item);
      if (pricePerMovie != null && this.pricePerMovieMatchesRange(pricePerMovie, rangeKey)) {
        filteredItems.push(item);
      }
    }
    return filteredItems;
  }

  private getSelectedPricePerMovieRangeKey(): string {
    if (!this.selectedPricePerMovieRanges || !this.selectedPricePerMovieRanges[0] ||
      this.selectedPricePerMovieRanges[0].key == null) {
      return '';
    }
    return this.selectedPricePerMovieRanges[0].key.toString();
  }

  private getPricePerMovieValueForItem(item: any): number {
    if (!item) {
      return null;
    }

    let itemCount = item.itemCount;
    if ((!itemCount || itemCount <= 0) && item.childMovies && item.childMovies.length > 0) {
      itemCount = item.childMovies.length;
    }
    if (!itemCount || itemCount <= 0) {
      return null;
    }

    let price = null;
    if (item.priceHd != null) {
      price = item.priceHd;
    }
    else if (item.priceSd != null) {
      price = item.priceSd;
    }
    else if (item.price4k != null) {
      price = item.price4k;
    }

    if (price == null) {
      return null;
    }
    return parseFloat(price) / parseFloat(itemCount);
  }

  private pricePerMovieMatchesRange(pricePerMovie: number, rangeKey: string): boolean {
    if (!this.isValidPriceRangeKey(rangeKey)) {
      return false;
    }

    if (rangeKey.charAt(0) === 'u') {
      return pricePerMovie <= parseFloat(rangeKey.substr(1));
    }
    if (rangeKey.charAt(0) === 'o') {
      return pricePerMovie >= parseFloat(rangeKey.substr(1));
    }
    if (rangeKey.indexOf('-') > 0) {
      const parts = rangeKey.split('-');
      return pricePerMovie >= parseFloat(parts[0]) && pricePerMovie <= parseFloat(parts[1]);
    }
    return pricePerMovie === parseFloat(rangeKey);
  }

  private isValidPriceRangeKey(rangeKey: string): boolean {
    if (!rangeKey) {
      return false;
    }

    if (/^u[0-9]+(\.[0-9]+)?$/.test(rangeKey) || /^o[0-9]+(\.[0-9]+)?$/.test(rangeKey) ||
      /^[0-9]+(\.[0-9]+)?$/.test(rangeKey)) {
      return true;
    }

    if (/^[0-9]+(\.[0-9]+)?-[0-9]+(\.[0-9]+)?$/.test(rangeKey)) {
      const parts = rangeKey.split('-');
      return parseFloat(parts[0]) <= parseFloat(parts[1]);
    }

    return false;
  }

  getGenreStorageKey(): string {
    return StorageHelper.keys.genre + '_' + Global.getStore() +
    '_' + Global.getCountry() + '_' + Global.getMediaType() + '_' + this.listType;
  }

  /**
   *
   * @param callback Function to execute once genres are loaded. must then take care of setting back isLoading and showSpinner to false
   * @returns
   */
  getGenres(callback?: () => void) {
    if (this.genresService != null) { //WishlistComponent extends this class with a null genreService
      this.isLoading = true;
      this.showSpinner = true;
      return this.genresService.getGenres(Global.getStore(), Global.getCountry(), Global.getMediaType())
        .pipe(takeUntil(this.destroy$))
      .subscribe(res => {
        if (res && res['results']){
          const genresFromServer = res['results'][Global.getGenreMediaType(Global.getMediaType())];
          if (genresFromServer) {
            this.genres = genresFromServer.map((g) => ({key: g.id, value: g.title}));
            if(this.genres && this.genres[0]) {
              this.genres[0].value = this.getString('all');
            }
          }
          if (this.cacheGenres) {
            this.addToCache(this.genres, 'genres');
          }

          if (this.genres && this.genres.length > 0){
            this.updateGenreSelection();
          }

          if (callback) { callback(); }
          else {
            this.isLoading = false;
            this.showSpinner = false;
          }
        }
      }, err => {
        this.isLoading = false;
        this.showSpinner = false;
        Log.getInstance().d(err);
      });
    }
  }

  getDate(item) {

    if (!item) {
      return '';
    }

    if (this.sortKey === Global.RELEASE_DATE) {
      return item.releaseDate;
    }
    if (this.sortKey === Global.LATEST_PRICE_CHANGE) {
      const priceKey = PriceHelper.getCompletePriceKey('LastChangeDate', 'offerslist', item, false);
      return item[priceKey];
    }
    if (this.sortKey === Global.UPGRADE_DATE) {
      return item['turned4K'];
    }
    if (this.sortKey === Global.UPGRADE_DATE_3D) {
      return item['turned3D'];
    }

    return '';
  }

  getDevices(): Array<any> {
    return [
      { title: Global.DEVICE_IPHONE, type: Global.DEVICE_TYPE_IPHONE },
      { title: Global.DEVICE_IPAD, type: Global.DEVICE_TYPE_IPAD },
      { title: Global.DEVICE_VISION_PRO, type: Global.DEVICE_TYPE_VISION_PRO },
      { title: Global.DEVICE_VISION_PRO_ONLY, type: Global.DEVICE_TYPE_VISION_PRO_ONLY }

    ];
  }

  getAdvisoryRatings(): CustomMap[] {
    if (Global.getMediaType() === Global.BUYMOVIES || Global.getMediaType() === Global.RENTALMOVIES) {
      return [
        {key: 'all', value: this.getString('all')},
        {key: 'G', value: this.getString('G')},
        {key: 'PG', value: this.getString('PG')},
        {key: 'PG-13', value: this.getString('PG-13')},
        {key: 'R', value: this.getString('R')},
        {key: 'Unrated', value: this.getString('Unrated')}
      ];
    }
    else { //only seasons use this
      return [
        {key: 'all', value: this.getString('all')},
        {key: 'TV-Y', value: this.getString('TV-Y')},
        {key: 'TV-Y7', value: this.getString('TV-Y7')},
        {key: 'TV-G', value: this.getString('TV-G')},
        {key: 'TV-PG', value: this.getString('TV-PG')},
        {key: 'TV-14', value: this.getString('TV-14')},
        {key: 'TV-MA', value: this.getString('TV-MA')}
      ];
    }
  }

  getMoviesAnywhereOptions(): Array<any> {
    return [
      { title: 'all', type: 'all' },
      { title: 'moviesAnywhereIncluded', type: '1' },
      { title: 'moviesAnywhereExcluded', type: '2' }
    ];
  }

  getItunesExtrasOptions(): Array<any> {
    return [{title: 'all', type: '0'}, {title: 'itunesExtrasOnly', type: '1'}];
  }

  getFrenchTitlesOptions(): Array<any> {
    return [{title: 'hide', type: 'hide'}, {title: 'show', type: 'show'}];
  }

  getOfferFilterOptions(): Array<any> {
    return [{ title: 'all', type: 'all' }, { title: 'dealsOnly', type: 'deals_only' }, { title: 'lowestOnly', type: 'lowest_only' }, { title: 'bestpriceOnly', type: 'bestprice_only' }];
  }

  getAudiotrackOptions(): Array<any> {
    return [{title: 'all', type: 'all'}, {title: 'english', type: 'en'}, {title: 'german', type: 'de'}];
  }

  getBundleFilterOptions(): Array<any> {
    const mediaType = Global.getMediaType();
    const isMovies = mediaType === Global.BUYMOVIES || mediaType === Global.RENTALMOVIES ||
      mediaType === Global.MOVIES || this.selectedMediaType === 'movies';
    const onlyLabel = isMovies ? 'moviesOnly' : 'seasonsOnly';
    return [
      { title: 'all', type: 'all' },
      { title: 'bundlesOnly', type: '1' },
      { title: onlyLabel, type: '0' }
    ];
  }

  getSoundOptions(): Array<any> {
    return [{title: 'all', type: 'all'}, {title: 'dolbyAtmosOnly', type: 'dolby_atmos'}];
  }

  getHdrFormatOptions(): CustomMap[] {
    if (Global.getStore() === Global.ITUNES) {
      return [
        {key: 'all', value: this.getString('all')},
        {key: 'hdr', value: this.getString('hdr')},
        {key: 'dolby_vision', value: this.getString('dolbyVision')},
      ];
    }
    else {
      return [
        {key: 'all', value: this.getString('all')},
        {key: 'hdr', value: this.getString('hdr')},
      ];
    }
  }

  getStudioOptions(): CustomMap[] {
    const studios: CustomMap[] = Config.studios.map(x => {
      if(x.id) {
        return { key: x.id, value: x.title };
      }
      else {
        return { key: x, value: x }
      }
    });
    studios.unshift({key: "", value: this.getString('all')});
    return studios;
  }

  getPriceTypes(): Array<any> {
    return [
      { title: Global.PRICE_PAID, type: Global.PRICE_TYPE_PAID },
      { title: Global.PRICE_FREE, type: Global.PRICE_TYPE_FREE }
    ];
  }

  getBuyRentOptions(): Array<any> {
    return [
      { title: 'moviesToBuy', type: 'buy' },
      { title: 'moviesToRent', type: 'rent' }
    ];
  }

  qualityOptionsHook(qualities): Array<any> {
    return qualities; //default behaviour
  }

  getQualityOptions(): Array<any> {
    const store = Global.getStore();
    let qualities;
    if (Global.getMediaType() === Global.RENTALMOVIES || Global.getMediaType() === Global.BUYMOVIES) {
      if (store === 'vudu' || store == 'googlePlay') {
        qualities = [
          { title: 'HD/4K', type: 'hd4k' },
          { title: '4K', type: '4k' },
          { title: 'HD', type: 'hd' },
          { title: 'SD', type: 'sd'}
        ];
      }
      else if (store === 'amazon') {
        qualities = [
          { title: 'HD', type: 'hd' },
          { title: 'SD', type: 'sd'}
        ];
      }
      else {
        qualities = [
          { title: 'HD/4K', type: 'hd4k' },
          { title: '4K', type: '4k' },
          { title: 'SD', type: 'sd' },
          { title: 'SD Only', type: 'sdOnly' }
        ];
      }
    }
    else {
      if (store === 'vudu' || store == 'googlePlay') {
        qualities = [
          { title: 'HD/4K', type: 'hd4k' },
          { title: '4K', type: '4k' },
          { title: 'HD', type: 'hd' },
          { title: 'SD', type: 'sd' }
        ];
      }
      else {
        qualities = [
          { title: 'HD/4K', type: 'hd' },
          { title: 'SD', type: 'sd' },
          { title: 'SD Only', type: 'sdOnly' }
        ];
      }
    }
    return this.qualityOptionsHook(qualities);

  }

  getMusicOptions(): Array<any> {
    return [
      { title: 'albums', type: 'albums' },
      { title: 'singles', type: 'singles' },
    ];
  }

  getPriceRangeOptions(): Array<any> {
    let mediaForPriceRange = Global.getMediaType();
    if (mediaForPriceRange === Global.BUYMOVIES || mediaForPriceRange === Global.RENTALMOVIES) {
      if (this.listType === 'bundles'){
        mediaForPriceRange = 'moviesBundles';
      }
    }
    else if (mediaForPriceRange === Global.SEASONS && this.listType === 'bundles') {
      mediaForPriceRange = 'seasonsBundles';
    }
    let priceRange = Global.priceRanges[mediaForPriceRange][Global.getCountry()];
    if (!priceRange) {
      priceRange = Global.priceRanges[mediaForPriceRange]['us']; // US by default
    }

    return this.getFormattedPriceRangeOptions(priceRange, mediaForPriceRange);
  }

  getPricePerMovieRangeOptions(): Array<any> {
    let priceRange = Global.priceRanges[Global.BUYMOVIES][Global.getCountry()];
    if (!priceRange) {
      priceRange = Global.priceRanges[Global.BUYMOVIES]['us'];
    }
    return this.getFormattedPriceRangeOptions(priceRange, Global.BUYMOVIES);
  }

  getFormattedPriceRangeOptions(priceRange: Array<any>, mediaForPriceRange: string): Array<any> {
    const priceRangesToReturn: any[] = [];
    if (mediaForPriceRange === "ebooks") {
      priceRangesToReturn.push({value: this.getString('free'), key: '0'});
    }

    priceRange.forEach(el => {
      if (el.key === 'for') {
        priceRangesToReturn.push({ value: StringHelper.format(
          this.getString('priceRange_for'),
          PriceHelper.formatPrice(el.price,
            Global.countries[Global.getCountry()].currency, true, true, false)),
        key: el.price.toFixed(2) });
      }
      else if (el.key === 'under') {
        priceRangesToReturn.push({ value: StringHelper.format(
          this.getString('priceRange_under'),
          PriceHelper.formatPrice(el.price,
            Global.countries[Global.getCountry()].currency, true, true, false)),
            key: 'u' + el.price.toFixed(2) });
      }
      else if (el.key === 'between') {
        priceRangesToReturn.push({ value: StringHelper.format(
          this.getString('priceRange_between'),
          PriceHelper.formatPrice(el.price1,
            Global.countries[Global.getCountry()].currency, true, true, false),
          PriceHelper.formatPrice(el.price2,
            Global.countries[Global.getCountry()].currency, true, true, false)),
            key: el.price1.toFixed(2) + '-' + el.price2.toFixed(2) });
      }
      else if (el.key === 'over') {
        priceRangesToReturn.push({ value: StringHelper.format(
          this.getString('priceRange_over'),
          PriceHelper.formatPrice(el.price,
            Global.countries[Global.getCountry()].currency, true, true, false)),
        key: 'o' + el.price.toFixed(2) });
      }
    });

    return priceRangesToReturn;
  }

  getQuality() {
    const quality = this.getValidOptionOrDefault(this.selectedQuality || this.getSavedQuality(), this.getQualityOptions(), 'type', StorageHelper.keys.quality);
    return quality ? quality["type"] : "";
  }

  getSavedQuality() {
    return StorageHelper.getInstance().getFilter(Global.getStore(), Global.getMediaType(), this.listType, StorageHelper.keys.quality);
  }

  getPriceTypeForServer(): string {
    const priceType = this.getValidOptionOrDefault(this.selectedPriceType || this.getPriceType(), this.getPriceTypes(), 'type', StorageHelper.keys.priceType);
    return priceType ? priceType["type"] : "";
  }

  showDateSeparator(item, i){
    const itemKeys = Object.keys(item);
    if (!item || !itemKeys || itemKeys.length === 0) {
      return false;
    }
    if (this.sortKey === Global.LATEST_PRICE_CHANGE) {
      const priceKey = PriceHelper.getCompletePriceKey('LastChangeDate', 'offerslist', item, false);
      const previousItemPriceKey = PriceHelper.getCompletePriceKey('LastChangeDate', 'offerslist', this.items[i - 1], false);
      if (i === 0 || ((this.items[i][priceKey] !== this.items[i - 1][previousItemPriceKey]) &&
      this.items[i][priceKey] != null && this.items[i - 1][previousItemPriceKey] != null)) {
        return true;
      }
    }

    if (this.sortKey === Global.RELEASE_DATE) {
      if (this.listType === 'preorder') {
        if (!this.items[i - 1]) {
          return true;
        }
        const relDate1 = new Date(this.items[i].releaseDate);
        const relDate2 = new Date(this.items[i - 1].releaseDate);
        relDate1.setHours(relDate1.getHours() + 12);
        relDate2.setHours(relDate2.getHours() + 12);
        if (relDate1 && relDate2 && relDate1.getMonth() !== relDate2.getMonth()){
          //console.log(relDate1, relDate2, i);
          return true;
        }
      }
      if (this.listType === 'recentlyadded' || this.listType === 'justreleased') {
        if (!this.items[i - 1]) {
          return true;
        }
        if (this.items[i].releaseDate !== this.items[i - 1].releaseDate) {
          return true;
        }
      }
    }

    if (this.sortKey === Global.UPGRADE_DATE || this.sortKey == Global.UPGRADE_DATE_3D) {
      let key = "turned4K";

      if (this.sortKey == Global.UPGRADE_DATE_3D) key = "turned3D";
      if (!this.items[i - 1]) {
        return true;
      }
      const date1 = new Date(this.items[i][key]);
      const date2 = new Date(this.items[i - 1][key]);
      date1.setHours(0, 0, 0);
      date2.setHours(0, 0, 0);
      if (date1.getTime() !== date2.getTime()) {
        return true;
      }
    }

    return false;

  }

  storeChanged() {
    this.items = [];
    this.changeListTypeIfNotValid();
    this.initSorting();
    this.initMediaTypes();
    this.initHdrFormat();
    this.initQuality();
    this.initPricePerMovieRange();
    this.reload(true);
  }

  changeListTypeIfNotValid() {
    const categoryForMedia = Global.lists.filter(l => l.store == Global.getStore())[0].categories.filter(c => c.mediaType == Global.getMediaType())[0];
    if(categoryForMedia) {
      if(categoryForMedia.items.map(i => i.listType).indexOf(this.listType) == -1) {
        this.listType = Global.ON_SALE;
        StorageHelper.getInstance().save(StorageHelper.keys.listType, this.listType);
      }
    }
  }

  qualityChanged(quality) {
    this.selectedQuality = quality;
    StorageHelper.getInstance().saveFilter(Global.getStore(), Global.getMediaType(), this.listType, StorageHelper.keys.quality, quality);
    this.reload(false);
  }

  mediaChanged(mediaType) {
    this.items = [];
    this.selectedMediaType = Global.getMediaTypeForSelector(mediaType);

    if (mediaType === 'movies'){
      mediaType = Global.BUYMOVIES;
      this.initBuyRentOptions();
    }
    else if (mediaType === 'music'){
      mediaType = 'albums';
    }

    StorageHelper.getInstance().save(StorageHelper.keys.mediaType, mediaType);
    this.initSorting();
    StorageHelper.getInstance().clear(StorageHelper.keys.priceRange);
    StorageHelper.getInstance().clear(StorageHelper.keys.pricePerMovieRange);
    StorageHelper.getInstance().clear(StorageHelper.keys.priceType);
    StorageHelper.getInstance().clear(StorageHelper.keys.quality);
    this.initPriceTypes();
    this.initPriceRange();
    this.initPricePerMovieRange();
    this.initQuality();
    this.initAdvisoryRating();
    this.initRuntime();
    this.initFrenchTitles();
    this.initSound();
    this.initMoviesAnywhere();
    this.initItunesExtras();
    this.initHdrFormat();
    this.initStudio();
    this.initMovieRatingsFilters();
    this.initAudiotrackOptions();
    this.initBundleFilter();

    this.initOffersFilter();

    this.reload(true);
  }

  genreChanged(genreObj: CustomMap[]) {
    this.selectedGenres = genreObj;
    StorageHelper.getInstance().save(this.getGenreStorageKey(), this.selectedGenres);
    this.reload(false);
  }

  deviceChanged(deviceObj) {
    this.selectedDevice = deviceObj;
    StorageHelper.getInstance().saveFilter(Global.getStore(), Global.getMediaType(), this.listType, StorageHelper.keys.device, this.selectedDevice);
    this.reload(false);
  }

  priceTypeChanged(priceTypeObj) {
    this.selectedPriceType = priceTypeObj;
    StorageHelper.getInstance().saveFilter(Global.getStore(), Global.getMediaType(), this.listType, StorageHelper.keys.priceType, priceTypeObj);
    this.reload(false);
  }

  priceRangeChanged(priceRangeObj) {
    StorageHelper.getInstance().saveFilter(Global.getStore(), Global.getMediaType(), this.listType, StorageHelper.keys.priceRange, priceRangeObj);
    //if it's the same do not reload
    if(this.selectedPriceRanges && priceRangeObj && this.selectedPriceRanges[0] && priceRangeObj[0] &&
      this.selectedPriceRanges[0].key != priceRangeObj[0].key){
        this.selectedPriceRanges = priceRangeObj;
        this.reload(false);
    }
  }

  pricePerMovieRangeChanged(priceRangeObj) {
    StorageHelper.getInstance().saveFilter(Global.getStore(), Global.getMediaType(), this.listType,
      StorageHelper.keys.pricePerMovieRange, priceRangeObj);
    if (this.selectedPricePerMovieRanges && priceRangeObj && this.selectedPricePerMovieRanges[0] && priceRangeObj[0] &&
      this.selectedPricePerMovieRanges[0].key !== priceRangeObj[0].key) {
        this.selectedPricePerMovieRanges = priceRangeObj;
        this.reload(false);
    }
  }

  releaseYearChanged(releaseYear) {
    StorageHelper.getInstance().saveFilter(Global.getStore(), Global.getMediaType(), this.listType, StorageHelper.keys.releaseYear, releaseYear);
    //if it's the same do not reload
    if(this.selectedReleaseYear != releaseYear) {
      this.selectedReleaseYear = releaseYear;
      this.reload(false);
    }
  }

  runtimeChanged(runtime) {
    StorageHelper.getInstance().saveFilter(Global.getStore(), Global.getMediaType(), this.listType, StorageHelper.keys.runtime, runtime);
    //if it's the same do not reload
    if(this.selectedRuntime != runtime) {
      this.selectedRuntime = runtime;
      this.reload(false);
    }
  }

  frenchTitlesChanged(frenchTitlesOption) {
    this.selectedFrenchTitlesOption = frenchTitlesOption;
    StorageHelper.getInstance().saveFilter(Global.getStore(), Global.getMediaType(), this.listType, StorageHelper.keys.hideFrenchTitles, frenchTitlesOption);
    this.reload(false);
  }

  sortChanged(list: string, sortKey: string) {
    this.sortKey = sortKey;
    this.items = [];
    StorageHelper.getInstance().saveFilter(Global.getStore(), Global.getMediaType(), list, StorageHelper.keys.sort, sortKey);
    this.reload(false);
  }

  sortPeriodChanged(sortPeriodKey: string) {
    this.sortPeriodKey = sortPeriodKey;
    this.items = [];
    StorageHelper.getInstance().saveFilter(Global.getStore(), Global.getMediaType(), Global.getListType(), StorageHelper.keys.sortPeriod, sortPeriodKey);
    this.reload(false);
  }

  buyRentChanged(buyRentOption) {
    this.buyRentSelectedOption = buyRentOption;
    StorageHelper.getInstance().save(StorageHelper.keys.buyRent, this.buyRentSelectedOption);
    this.reload(false);
  }

  musicOptionChanged(musicOption) {

    if(musicOption) {
      this.selectedMusicOption = musicOption;
      let mediaType;
      if (this.selectedMusicOption["type"] === 'albums') {
        mediaType = 'albums';
      }
      else if (this.selectedMusicOption["type"] === 'singles') {
        mediaType = 'singles';
      }

      StorageHelper.getInstance().save(StorageHelper.keys.mediaType, mediaType);
      this.initSorting();
      this.initPriceTypes();
      this.initPriceRange();
      this.reload(false);
    }

  }

  advisoryRatingChanged(advisoryRatings) {
    this.selectedAdvisoryRatings = advisoryRatings;
    StorageHelper.getInstance().saveFilter(Global.getStore(), Global.getMediaType(), this.listType, StorageHelper.keys.advisoryRating, advisoryRatings);
    this.reload(false);
  }

  moviesAnywhereChanged(moviesAnywhereOption) {
    this.selectedMAOption = moviesAnywhereOption;
    StorageHelper.getInstance().saveFilter(Global.getStore(), Global.getMediaType(), this.listType, StorageHelper.keys.moviesAnywhere, moviesAnywhereOption);
    this.reload(false);
  }

  itunesExtrasChanged(itunesExtrasOption) {
    this.selectedItunesExtrasOption = itunesExtrasOption;
    StorageHelper.getInstance().saveFilter(Global.getStore(), Global.getMediaType(), this.listType, StorageHelper.keys.itunesExtras, itunesExtrasOption);
    this.reload(false);
  }

  offersFilterChanged(offersFilterOption) {
    this.selectedOffersFilterOption = offersFilterOption;
    StorageHelper.getInstance().saveFilter(Global.getStore(), Global.getMediaType(), this.listType, StorageHelper.keys.offersFilter, offersFilterOption);
    this.reload(false);
  }

  soundChanged(soundOption) {
    this.selectedSoundOption = soundOption;
    StorageHelper.getInstance().saveFilter(Global.getStore(), Global.getMediaType(), this.listType, StorageHelper.keys.sound, soundOption);
    this.reload(false);
  }

  hdrFormatChanged(hdrFormatOptions: CustomMap[]) {
    this.selectedHdrFormatOptions = hdrFormatOptions;
    StorageHelper.getInstance().saveFilter(Global.getStore(), Global.getMediaType(), this.listType, StorageHelper.keys.hdrFormat, hdrFormatOptions);
    this.reload(false);
  }

  studioChanged(studioOptions: CustomMap[]) {
    this.selectedStudioOptions = studioOptions;
    StorageHelper.getInstance().saveFilter(Global.getStore(), Global.getMediaType(), this.listType, StorageHelper.keys.studio, studioOptions);
    this.reload(false);
  }

  audiotrackChanged(audiotrackOption) {
    this.selectedAudiotrackOption = audiotrackOption;
    StorageHelper.getInstance().saveFilter(Global.getStore(), Global.getMediaType(), this.listType, StorageHelper.keys.audiotrack, audiotrackOption);
    this.reload(false);
  }

  bundleFilterChanged(bundleFilterOption) {
    this.selectedBundleFilterOption = bundleFilterOption;
    StorageHelper.getInstance().saveFilter(Global.getStore(), Global.getMediaType(), this.listType, StorageHelper.keys.showBundles, bundleFilterOption);
    this.reload(false);
  }

  itemClicked(e, item){

    if (!item) {
      return;
    }

    this.saveScrollPosition();

    StorageHelper.getInstance().save(StorageHelper.keys.detailViewMediaType, Global.getMediaType());

  }

  saveScrollPosition() {
    const cache = Cache.getInstance();
    cache.saveScrollPosition(this.router.url, window.scrollY);
  }

  setScrollPosition() {
    const cache = Cache.getInstance();
    const scrollPos = cache.getScrollPosition(this.router.url);
    cache.deleteScrollPosition(this.router.url); //To ensure that it is only used one time
    if (scrollPos) {
      window.scrollTo(0, scrollPos); //x, y
    }
  }

  getSessionTokenFromUrl() {
    //Notifier
    const ngUnsubscribe: Subject<any> = new Subject();

    this.route.params.pipe(takeUntil(ngUnsubscribe.asObservable())) //take values until a notifier emits a value
    .subscribe(params => {
      //Check if there is a sessionToken in the url, if yes,
      //The user probably has been redirected on in the app,
      //Get the user data
      const sessionToken = params['sessionToken'];
      const country = params['country'];
      if (sessionToken) {
        this.infoService.getUserDataBySessionToken(sessionToken, country).subscribe(result => {
          StorageHelper.getInstance().save(StorageHelper.keys.sessionToken, sessionToken);
          StorageHelper.getInstance().save(StorageHelper.keys.username, result['username']);
          StorageHelper.getInstance().save(StorageHelper.keys.email, result['mail']);
          StorageHelper.getInstance().save(StorageHelper.keys.profileImageUrl, result['profileImage']);
          StorageHelper.getInstance().save(StorageHelper.keys.uniqueCustomerId, result['uniqueCustomerId']);
          this.authenticationService.setIsLoggedIn(true);
          LoginHelper.getInstance().loginChanged(true);

          if(this.identifier != Global.MY_PURCHASES) {
            this.getShortOwnList();
          }
          if(this.identifier != Global.BLOCKLIST) {
            this.getShortBlocklist();
          }

          this.getShortWishlist();

        }, err => {});
      }

      //notifies that params have been received and route.params can be unsubscribed
      ngUnsubscribe.next();
      ngUnsubscribe.complete();

    });

  }

  getShortWishlist() {
    const sessionToken = StorageHelper.getInstance().get(StorageHelper.keys.sessionToken);

    if (sessionToken){
      this.wishlistService.getShortWishlist(
        Global.getCountry(),
        Global.getStore(),
        sessionToken
      ).subscribe(res => {
        if (res && res['results']) {
          const shortWishlist = StorageHelper.getInstance().get(StorageHelper.keys.shortWishlist) || {};
          shortWishlist[Global.getStore()] = res["results"];
          const saved = StorageHelper.getInstance().save(StorageHelper.keys.shortWishlist, shortWishlist);
          if (saved) {
            // Clear cache to force reload on next access
            ListHelper.clearWishlistCache();
          } else {
            // If save failed, log error but don't crash
            Log.getInstance().d('Failed to save wishlist to storage - storage may be full');
          }
        }

      },
      err => {
        Log.getInstance().d(err);
      });
    }

  }

  getShortBlocklist() {
    const sessionToken = StorageHelper.getInstance().get(StorageHelper.keys.sessionToken);

    if (sessionToken){
      this.blocklistService.getShortBlocklist(
        Global.getCountry(),
        Global.getStore(),
        sessionToken
      ).subscribe(res => {
        if (res && res['results']) {
          const shortBlocklist = StorageHelper.getInstance().get(StorageHelper.keys.shortBlocklist) || {};
          shortBlocklist[Global.getStore()] = res["results"];
          const saved = StorageHelper.getInstance().save(StorageHelper.keys.shortBlocklist, shortBlocklist);
          if (saved) {
            // Clear cache to force reload on next access
            ListHelper.clearBlocklistCache();
          } else {
            // If save failed, log error but don't crash
            Log.getInstance().d('Failed to save blocklist to storage - storage may be full');
          }
        }

      },
      err => {
        Log.getInstance().d(err);
      });
    }

  }

  getShortOwnList() {
    const sessionToken = StorageHelper.getInstance().get(StorageHelper.keys.sessionToken);

    if (sessionToken) {
      this.ownlistService.getShortItemList(
        sessionToken,
        Global.getStore(),
        Global.getCountry()
      ).subscribe(res => {
        if (res && res['results']) {
          const shortOwnlist = StorageHelper.getInstance().get(StorageHelper.keys.shortOwnlist) || {};
          shortOwnlist[Global.getStore()] = res["results"];
          const saved = StorageHelper.getInstance().save(StorageHelper.keys.shortOwnlist, shortOwnlist);
          if (saved) {
            // Clear cache to force reload on next access
            ListHelper.clearOwnlistCache();
          } else {
            // If save failed, log error but don't crash
            Log.getInstance().d('Failed to save ownlist to storage - storage may be full');
          }
        }
      },
      err => {
        Log.getInstance().d(err);
      });
    }
  }

  isCountry(countryCode): boolean {
    return StorageHelper.getInstance().get(StorageHelper.keys.country) === countryCode;
  }

  getActiveMovieRatingsFilters(): string {
    const array = [];
    if (this.movieRatingsFilters.imdb > 0) {
      array.push(this.getString('imdb'));
    }
    if (this.movieRatingsFilters.rotten > 0) {
      array.push(this.getString('rotten'));
    }
    if (this.movieRatingsFilters.letterboxd > 0) {
      array.push('Letterboxd');
    }
    if (this.movieRatingsFilters.metacritic > 0) {
      array.push(this.getString('meta'));
    }
    if (array.length === 0){
      return this.getString('none');
    }
    return array.join(',');
  }

  applyMovieRatingsFilter(values: MovieRatingsFilters) {
    this.movieRatingsFilters = values;
    this.updateMovieRatingsSelection();
    StorageHelper.getInstance().saveFilter(Global.getStore(), Global.getMediaType(), this.listType, StorageHelper.keys.movieRatingsFilters, this.movieRatingsFilters);
    this.reload(false);
  }

  updateMovieRatingsSelection() {
    let text = "";
    let count = 0;
    if(this.movieRatingsFilters.metacritic > 0) {
      text = "Metacritic " + this.movieRatingsFilters.metacritic;
      count ++;
    }
    if(this.movieRatingsFilters.rotten > 0) {
      text = "Rotten " + this.movieRatingsFilters.rotten;
      count++;
    }
    if (this.movieRatingsFilters.letterboxd > 0) {
      text = "Letterboxd " + this.movieRatingsFilters.letterboxd;
      count++;
    }
    if(this.movieRatingsFilters.imdb > 0) {
      text = "IMDb " + this.movieRatingsFilters.imdb;
      count++;
    }
    if(count > 1) {
      text += " +" + (count - 1);
    }
    this.movieRatingsSelection = text || this.getString("all");
  }

  toggleFiltersPanel() {
    this.isFiltersPanelOpen = !this.isFiltersPanelOpen;
    FilterHelper.saveFilterOpen(this.isFiltersPanelOpen);
  }

  getStore() {
    return Global.getStore();
  }

  mediaSupportedForCountry(): boolean {
    let mediaType = Global.getMediaType();
    if (mediaType === Global.BUYMOVIES || mediaType === Global.RENTALMOVIES) {
      mediaType = 'movies';
    }
    else if (mediaType === Global.ALBUMS || mediaType === Global.SINGLES) {
      mediaType = 'music';
    }
    const countryMediaMatrix = Global.mediaMatrix[Global.getCountry()];
    return countryMediaMatrix ? countryMediaMatrix[mediaType] || false : false;
  }

  addToWishlist(item) {
    const id = item.idInStore || item.itemID;
    const ignoreSdPrice = this.shouldIgnoreSdPriceForMediaType(Global.getMediaType());
    this.wishlistService.addItem(Global.getCountry(), Global.getStore(), Global.getMediaType(),
    StorageHelper.getInstance().get(StorageHelper.keys.sessionToken), id, ignoreSdPrice).subscribe(res => {
      this.getShortWishlist();
    }, res => {

    });
  }

  /**
   * Checks if SD price should be ignored when adding to wishlist.
   * Only applies to movies and TV seasons.
   */
  protected shouldIgnoreSdPriceForMediaType(mediaType: string): boolean {
    const setting = StorageHelper.getInstance().get(StorageHelper.keys.ignoreSdPriceOnWishlist);
    // Default is true - only return false if explicitly set to false
    if (setting === false) {
      return false;
    }
    // Only apply to movies and TV seasons
    // Note: 'seasons' is the plural of 'season' itemType, 'tvSeasons' is the plural of 'tvSeason' itemType
    const movieAndTvTypes = ['movies', 'buyMovies', 'rentalMovies', 'seasons', 'tvSeasons'];
    return movieAndTvTypes.indexOf(mediaType) !== -1;
  }

  removeFromWishlist(item) {
    const id = item.idInStore || item.itemID;
    this.wishlistService.removeItem(Global.getCountry(), Global.getStore(), Global.getMediaType(),
    StorageHelper.getInstance().get(StorageHelper.keys.sessionToken), id).subscribe(res => {
      this.getShortWishlist();
    }, res => {

    });
  }

  addToBlocklist(item) {
    const id = item.idInStore || item.itemID;
    this.items = this.items.filter(it => it.idInStore != item.idInStore);
    this.blocklistService.addItem(Global.getCountry(), Global.getStore(), Global.getMediaType(),
    StorageHelper.getInstance().get(StorageHelper.keys.sessionToken), id).subscribe(res => {
      this.getShortBlocklist();
    }, res => {

    });
  }

  addToOwnlist(item) {
    const id = item.idInStore || item.itemID;
    this.ownlistService.addItem(Global.getCountry(), Global.getStore(), Global.getMediaType(),
    StorageHelper.getInstance().get(StorageHelper.keys.sessionToken), id).subscribe(res => {
      this.getShortOwnList();
    }, res => {

    });
  }

  removeFromOwnlist(item) {
    const id = item.idInStore || item.itemID;
    this.ownlistService.removeItem(Global.getCountry(), Global.getStore(), Global.getMediaType(),
    StorageHelper.getInstance().get(StorageHelper.keys.sessionToken), id).subscribe(res => {
      this.getShortOwnList();
    }, res => {

    });
  }

  getDownTriangleSrc(): string {
    return this.themeService.isDarkTheme() ? "./assets/images/white_down_triangle.png" : "./assets/images/black_down_triangle.png";
  }

  formatString(text: string, ...values: any[]): string {
    return StringHelper.format(text, values);
  }

}
